import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'households';

export const HOUSEHOLD_ENDPOINTS = {
  claimLowCreditBonus: () => formatEndpoint('credits/low-credit-bonus', namespace),
  removeMemberFromHousehold: (householdId: string, clientId: string) =>
    formatEndpoint(`${householdId}/remove-member/${clientId}`, namespace),
  retrieveCredits: () => formatEndpoint('ledger', namespace),
  retrieveFullLedgerReport: (params: { end: DateTimeISOString; start: DateTimeISOString }) =>
    formatEndpoint('ledger/report', namespace, {
      queryParams: {
        end: params.end,
        start: params.start,
      },
    }),
  retrieveHousehold: (id: string) => formatEndpoint(id, namespace),
};
